<i18n>
{
    "en_US": {
        "fail-password-confirm": "Password and confirmation aren't equal...",
        "nevermind": "Nevermind",
        "password-recover": "Recover your password",
        "reinit": "Recover"
    },
    "fr_FR": {
        "fail-password-confirm": "Le mot de passe et sa confirmation sont différents...",
        "nevermind": "Abandonner",
        "password-recover": "Réinitialiser votre mot de passe",
        "reinit": "Réinitialiser"
    }
}
</i18n>

<template>
    <form v-on:submit.prevent="recover">
        <h1 class="text-left" v-text="$t('password-recover')"></h1>

        <slot name="flashes" />

        <input-password-reveal v-model="password" v-bind:disabled="pending.password_recover" />
        <input-password-confirm v-model="confirm" v-bind:password="password" v-bind:disabled="pending.password_recover" />

        <button class="btn btn-lg btn-primary btn-block" type="submit" v-bind:disabled="isAllowedButton">
            <loader-basic-spinner v-if="pending.password_recover" />
            <a v-else v-text="$t('reinit')"></a>
        </button>

        <a class="nevermind" v-on:click="login" v-text="$t('nevermind')"></a>
    </form>
</template>

<script>
    import InputPasswordReveal from "inputs/PasswordReveal";
    import InputPasswordConfirm from "inputs/PasswordConfirm";
    import LoaderBasicSpinner from "loaders/BasicSpinner";
    import { mapState, mapMutations, mapActions } from "vuex";

    export default {
        name: "PasswordRecover",
        data: function() {
            return {
                passwordRecoverLink: "",
                password: "",
                confirm: ""
            };
        },
        components: {
            LoaderBasicSpinner,
            InputPasswordReveal,
            InputPasswordConfirm
        },
        mounted: function() {
            this.passwordRecoverLink = this.$route.params.password_lost_link;
            $(this.$el).bootstrapMaterialDesign();
            $(this.$el).find("#inputUsername").focus();
        },
        computed: {
            isAllowedButton: function() {
                return this.pending.password_recover || !this.password || !this.confirm;
            },
            ...mapState("user", ["pending"])
        },
        methods: {
            login: function() {
                this.$router.push({
                    name: "login"
                });
            },
            recover: function() {
                if(!this.password || !this.confirm || this.password !== this.confirm) {
                    this.addFlash({
                        type: "error",
                        message: this.$t("fail-password-confirm"),
                        onlyCurrentRoute: true
                    });
                    return;
                }

                // Do register
                this.passwordRecover({
                    passwordLostLink: this.passwordRecoverLink,
                    password: this.password,
                    confirm: this.confirm
                })
                .then(function() {
                    this.$Progress.finish();
                    this.$router.push({ name: "login" });
                }.bind(this))
                .catch(function() {});
            },
            ...mapMutations("flash", ["addFlash"]),
            ...mapActions("user", ["passwordRecover"])
        }
    }
</script>

<style scoped>
    h1 {
        margin-top: 20px;
        margin-bottom: 10px;
        color: #666;
        font-weight: 300;
        font-size: 20px;
    }
    img {
        margin-bottom: 10px;
    }
    .bmb-form-group {
        padding-top: 1.3rem !important;
    }
    button {
        margin-bottom: 0;
        margin-top: 10px;
        font-weight: 100;
        font-size: 18px !important;
        line-height: 1.3333333333;
    }
    .bmd-label-floating {
        left: 0;
    }
    .nevermind {
        display: block;
        margin-top: 25px;
        font-size: 14px;
        font-weight: 300;
        cursor: pointer;
    }
    .form-group label {
        font-weight: bold;
        font-size: 14px;
    }
    .container-fluid {
        margin-top: 30px;
    }
    .href {
        color: #3e8ef7;
        font-weight: 100;
        font-size: 14px;
        cursor: pointer;
    }
    .btn-block {
        margin-top: 45px;
    }
</style>